import {
    ANGLES_ITEMS,
    COLUMN_ITEMS,
    DragItemType,
    GridType,
    MINI_ANGLES_ITEMS,
    ROW_ITEMS,
    SQUARE_ITEMS,
    TypeOfItemsAngles,
    TypeOfItemsCol,
    TypeOfItemsMiniAngles,
    TypeOfItemsRow,
} from "../../types";
import {isRange} from "./isRange";

export function validatePosition(column: number, row: number, copyGridData: GridType, dragItem: DragItemType) {
    if (dragItem.typeOfItem === 'SINGLE' || dragItem.typeOfItem === 'BOMB') {
        if (!copyGridData[column][row].item) {
            return [[column, row]];
        }
    }

    // двойная или более строка или столбец
    const isColumn = COLUMN_ITEMS.includes(dragItem.typeOfItem as TypeOfItemsCol);
    const isRow = ROW_ITEMS.includes(dragItem.typeOfItem as TypeOfItemsRow);

    // двойной или тройной куб
    const isDoubleSquare = SQUARE_ITEMS[0] === dragItem.typeOfItem;
    const isTripleSquare = SQUARE_ITEMS[1] === dragItem.typeOfItem;

    const isMiniAngle = MINI_ANGLES_ITEMS.includes(dragItem.typeOfItem as TypeOfItemsMiniAngles);
    const isAngle = ANGLES_ITEMS.includes(dragItem.typeOfItem as TypeOfItemsAngles);

    const MINI_ANGLE_LEFT_TOP = MINI_ANGLES_ITEMS[0] === dragItem.typeOfItem
    const MINI_ANGLE_RIGHT_TOP = MINI_ANGLES_ITEMS[1] === dragItem.typeOfItem
    const MINI_ANGLE_RIGHT_BOTTOM = MINI_ANGLES_ITEMS[2] === dragItem.typeOfItem
    const MINI_ANGLE_LEFT_BOTTOM = MINI_ANGLES_ITEMS[3] === dragItem.typeOfItem

    const ANGLE_LEFT_TOP = ANGLES_ITEMS[0] === dragItem.typeOfItem
    const ANGLE_LEFT_BOTTOM = ANGLES_ITEMS[1] === dragItem.typeOfItem
    const ANGLE_RIGHT_BOTTOM = ANGLES_ITEMS[2] === dragItem.typeOfItem
    const ANGLE_RIGHT_TOP = ANGLES_ITEMS[3] === dragItem.typeOfItem

    if (isColumn || isRow || isDoubleSquare || isTripleSquare || isMiniAngle || isAngle) {
        let items: any

        if (isAngle) {
            if (ANGLE_LEFT_TOP) {
                items = getLeftTopAngle(dragItem, copyGridData, column, row);
            }
            if (ANGLE_LEFT_BOTTOM) {
                items = getLeftBottomAngle(dragItem, copyGridData, column, row);
            }
            if (ANGLE_RIGHT_BOTTOM) {
                items = getRightBottomAngle(dragItem, copyGridData, column, row);
            }
            if (ANGLE_RIGHT_TOP) {
                items = getRightTopAngle(dragItem, copyGridData, column, row);
            }
        }

        if (isMiniAngle) {
            if (MINI_ANGLE_LEFT_TOP) {
                items = getLeftTopMiniAngle(dragItem, copyGridData, column, row);
            }

            if (MINI_ANGLE_RIGHT_TOP) {
                items = getRightTopMiniAngle(dragItem, copyGridData, column, row);
            }

            if (MINI_ANGLE_RIGHT_BOTTOM) {
                items = getRightBottomMiniAngle(dragItem, copyGridData, column, row);
            }

            if (MINI_ANGLE_LEFT_BOTTOM) {
                items = getLeftBottomMiniAngle(dragItem, copyGridData, column, row);
            }
        }

        if (isTripleSquare) {
            items = getTripleSquare(dragItem, copyGridData, column, row);
        }

        if (isDoubleSquare) {
            items = getDoubleSquare(dragItem, copyGridData, column, row);
        }

        if (isColumn || isRow) {
            items = getRowsOrColsItems(dragItem, copyGridData, column, row, isRow, isColumn);
        }
        // ничего не делаем если в массиве есть null, тк это значит
        // что на данном месте уже лежит другой элемент
        if (!items || items.includes(null)) return []

        return items as number[][];
    }

    return []
}

const getRightTopAngle = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => {
    return dragItem.items.map((_, index) => {
        const _column = index < 3 ? column + index : column;
        const _row = index > 2 ? row + index - 4 : row + 1;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }

        return null;
    })
}

const getRightBottomAngle = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => {
    return dragItem.items.map((_, index) => {
        const _column = index < 3 ? column - index + 1 : column + 1;
        const _row = index > 2 ? row - index + 2 : row;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }

        return null;
    })
}

const getLeftBottomAngle = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => {
    return dragItem.items.map((_, index) => {
        const _column = index < 3 ? column - index + 1 : column + 1;
        const _row = index > 2 ? row + index - 2 : row;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }

        return null;
    })
}

const getLeftTopAngle = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => {
    return dragItem.items.map((_, index) => {
        const _column = index < 3 ? column + index : column;
        const _row = index > 2 ? row + index - 3 : row - 1;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }

        return null;
    })
}

const getRightBottomMiniAngle = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => {
    return dragItem.items.map((_, index) => {
        const _column = index % 2 === 0 ? column : column - 1;
        const _row = index < 2 ? row : row - 1;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }

        return null;
    })
}

const getLeftBottomMiniAngle = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => {
    return dragItem.items.map((_, index) => {
        const _column = index % 2 === 0 ? column + 1 : column;
        const _row = index < 2 ? row : row + 1;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }

        return null;
    })
}

const getRightTopMiniAngle = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => {
    return dragItem.items.map((_, index) => {
        const _column = index % 2 === 0 ? column : column + 1;
        const _row = index < 2 ? row + 1 : row;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }

        return null;
    })
}

const getLeftTopMiniAngle = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => {
    return dragItem.items.map((_, index) => {
        const _column = index % 2 === 0 ? column : column + 1;
        const _row = index < 2 ? row : row + 1;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }

        return null;
    })
}

const getTripleSquare = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => (
    dragItem.items.map((_, index) => {
        const offsetX = index % 3;
        const offsetY = Math.floor(index / 3);
        const _column = column + offsetX;
        const _row = row + offsetY - 1;

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }
        return null;
    })
)

const getDoubleSquare = (dragItem: DragItemType, copyGridData: GridType, column: number, row: number) => (
    dragItem.items.map((_, index) => {
        let _column = column + (index === 2 || index === 3 ? 1 : 0);
        let _row = row + (index === 1 || index === 2 ? 1 : 0);

        if (isRange(_column, _row)) {
            if (copyGridData[_column][_row].item) return null;
            return [_column, _row];
        }
        return null;
    })
);


const getRowsOrColsItems = (
    dragItem: DragItemType,
    copyGridData: GridType,
    column: number,
    row: number,
    isRow: boolean,
    isColumn: boolean
) => (
    dragItem.items.map((_, index) => {
        const _column = isColumn ? column + index : column;
        const _row = isRow ? row + index : row;
        // Если внутри поля тогда пытаемся сделать замену
        if (isRange(_column, _row)) {
            // если ячейка занята, ничего не делаем
            if (copyGridData[_column][_row].item) return null;

            return [_column, _row];
        }
        return null;
    })
);
